'use client';
import { ProductCardContext } from '.';
import { ComponentProps, useContext } from 'react';
import { useGetLocalizedValue } from '@/shared/lib/hooks/useGetLocalizedValue';
import { Layout } from '@/shared/ui/layout';
import { ProductCardProps } from './types';

type Props = ComponentProps<typeof Layout> &
    Partial<Pick<ProductCardProps, 'description'>> & { maxLines?: number };

export const ProductCardDescription = ({ description, media, maxLines, ...props }: Props) => {
    const context = useContext(ProductCardContext);
    const getLocalizedValue = useGetLocalizedValue();

    const finalDescription = getLocalizedValue(description ?? context.description ?? {});

    if (!finalDescription) {
        return null;
    }

    return (
        <Layout
            element="p"
            className="product-card__description"
            data-testid="product-card-description"
            media={{
                ...media,
                initial: {
                    ...(maxLines
                        ? {
                              overflow: 'hidden',
                              display: '-webkit-box',
                              lineClamp: maxLines,
                              '-webkit-line-clamp': maxLines,
                              '-webkit-box-orient': 'vertical',
                          }
                        : {}),
                    ...media?.initial,
                },
            }}
            {...props}
        >
            {finalDescription}
        </Layout>
    );
};
